import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-autoselect',
  templateUrl: './autoselect.component.html',
  styleUrls: ['./autoselect.component.scss']
})
export class AutoselectComponent implements OnInit, OnChanges {

  @Input() id = '';
  @Input() public group: FormGroup;
  @Input() public control: FormControl;
  @Input() public data;
  @Input() public label;
  @Input() public placeHolder;
  @Input() public icon;
  @Input() public fieldRequired = 'Field required';
  @Output() public onInput = new EventEmitter<string>();
  @Output() public onFocus = new EventEmitter<string>();
  @Output() public onSelect = new EventEmitter<any>();
  @ViewChild('inputELement', { static: true }) inputELement: ElementRef<HTMLInputElement>;
  public filter: Observable<any>;
  selected;
  onChangeValueSet = true;

  constructor() { }

  ngOnInit() {
    this.filterListner();
    this.getInputOninit();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.filterListner();
    if (changes.control && changes.control.currentValue.value) {
      this.selected = this.control.value;
    }
  }
  /**Get input on init */
  getInputOninit() {
    if (this.control?.value) {
      this.selected = this.control.value;
    }
  }

  /**On input */
  onInputFunc(event) {
    this.onInput.emit(event);
  }

  /**On focus */
  onFocusFunc(event) {
    this.onFocus.emit(event);
  }
  /**Get the error message */
  getErrorMessage(control: FormControl) {
    switch (true) {
      case control.hasError('required'):
        return 'Field required';
      case control.hasError('notfound'):
        return 'NGO not found';
    }
  }
  /**Get Ngo error */
  getNgoError() {
    if (!this.data?.length) {
      return this.selected ? false : true;
    }
  }
  /**Filter logic of autocomplate */
  filterListner() {
    this.filter = this.control?.valueChanges?.pipe(
      startWith(''),
      map(item => item ? this.filterData(item) : this.data.slice())
    );
  }
  /**Filter citites for auto complete */
  filterData(name: string) {
    return this.data.filter(item => item.label.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  /**On select event of select option */
  selectChange(event, data) {
    if (event.isUserInput) {
      this.selected = data.label;
      this.onSelect.emit(data);
      this.inputELement.nativeElement.value = '';
      this.control.disable();
    }
  }
  /**Remove the chip from the input */
  removeChip() {
    this.selected = undefined;
    this.control.setValue('');
    this.onSelect.emit(null);
    this.control.enable();
  }

}
